// extracted by mini-css-extract-plugin
export default {"segment-container":"SettingsSegment_segment-container__NqxZJ"};